export const APPBELL_RIGHT = 'show-notification-bell';
